import type { MailboxInfo } from "owa-client-types";
import { copilotSettingsStore, FetchState, lazyFetchOcsCopilotSettings, } from "owa-copilot-settings-store";
import { isGlobalFeatureEnabled } from "owa-feature-flags";
import { getLinkedLicensingMailboxInfoOrSelf } from "owa-session-store";
import { isCopilotLicensedAndEnabledUser } from "./isCopilotLicensedAndEnabledUser";

export function isCalendarAiLabsBriefingEnabled(mailboxInfo: MailboxInfo): boolean {
    if (!isGlobalFeatureEnabled("cal-aiLabsBriefingFromPanel")) {
        return false;
    }
    
    return isCopilotLicensedAndEnabledUser(getLinkedLicensingMailboxInfoOrSelf(mailboxInfo));
}

export async function isCalendarAiLabsBriefingEnabledAsync(mailboxInfo: MailboxInfo): Promise<boolean> {
    if (!isGlobalFeatureEnabled("cal-aiLabsBriefingFromPanel")) {
        return false;
    }
    
    await lazyFetchOcsCopilotSettings.importAndExecute(mailboxInfo);
    
    const licensingMailboxInfo = getLinkedLicensingMailboxInfoOrSelf(mailboxInfo);
    let fetchState = copilotSettingsStore(licensingMailboxInfo).fetchState;
    if (fetchState !== FetchState.SUCCEEDED) {
        await lazyFetchOcsCopilotSettings.importAndExecute(mailboxInfo, true);
        fetchState = copilotSettingsStore(licensingMailboxInfo).fetchState;
    }
    
    if (fetchState !== FetchState.SUCCEEDED) {
        return false;
    }
    
    return isCalendarAiLabsBriefingEnabled(mailboxInfo);
}
